<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<header class="allfeatureHeader d-flex justify-content-center align-items-center position-relative">
  <div class="position-absolute graohicsHeader" style="right:0; top: 0">
    <img src="../../../assets/images/graphics3.png" class="img-fluid" alt="">
  </div>
  <div class="position-absolute graohicsHeader" style="left:0; bottom: 0">
    <img src="../../../assets/images/graphics4.png" class="img-fluid" alt="">
  </div>
  <div>
    <h1 class="f-40 font-weight-500 text-center text-white mb-2">Simple and Transparent Pricing</h1>
    <p class="f-18 font-weight-500 text-center text-white">Free to get started & affordable as you scale</p>
  </div>
</header>

<section *ngIf="paymentPage">
  <section class="tabBTnContainer">
    <div class="container">
      <div class="row">
        <div class="col-md-6 mx-auto  text-center">
          <p class="f-36 font-weight-600">Webbtree Talent Source</p>
          <div class="d-flex justify-content-sm-center justify-content-center flex-sm-row flex-column">
            <ul class="nav nav-pills" id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <a data-testid="auto-app-pricing-a-1" class="nav-link active monthlyYearlyBtn f-18" id="pills-profile-tab" data-bs-toggle="pill"
                  href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Yearly <span
                    class="monthfree ml-2">2 months free</span></a>
              </li>
              <li class="nav-item" role="presentation">
                <a data-testid="auto-app-pricing-a-2" class="nav-link  monthlyYearlyBtn f-18" id="pills-home-tab" data-bs-toggle="pill" href="#pills-home"
                  role="tab" aria-controls="pills-home" aria-selected="true">Monthly</a>
              </li>

            </ul>

          </div>
        </div>

      </div>

    </div>

  </section>
  <div class="tab-content" id="pills-tabContent">
    <div class="tab-pane fade" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
      <section>
        <div class="container-fluid px-0 pb-4">
          <div class="position-relative">
            <div class=" pricing-table-bg-gradient position-relative"> </div>
            <div class="position-absolute  top-center">
              <div class="container">
                <div class="row">
                  <div class="col d-flex flex-column flex-sm-row">
                    <div class="price-card">
                      <p class="f-22 font-weight-600 text-9696">Starter</p>
                      <p class="d-flex justify-content-between align-items-center"><span
                          class="f-22 font-weight-600 text-black">Free</span><span class="f-12  text-9696 ">No credit
                          card needed</span></p>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3"><i
                          class="fas fa-address-book price-text-color mr-1"></i> 10 Contact Credits
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Contact Credits</p>
                          <p class="f-12 mb-0 font-weight-normal">Get real time verified emails and direct dial phone
                            numbers of any LinkedIn profile at the click of a button.</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3">
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Profile Extractions</p>
                          <p class="f-12 mb-0 font-weight-normal">Extract all relevant information from candidate’s
                            profiles to maintain talent CRM</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600  wctooltip mb-3"><i
                          class="fas fa-search price-text-color mr-1"></i> Unlimited X-Ray Searches
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">X-Ray Searches</p>
                          <p class="f-12 mb-0 font-weight-normal">X-Ray search sites like LinkedIn, Github,
                            Stackoverflow and more without having to write complex boolean search strings.</p>
                        </div>
                      </div>

                      <div class="text-center">
                        <a data-testid="auto-app-pricing-a-3" class="select-plan-btn text-center" href="https://hire.webbtree.com/searchtoolbox-v2"
                          target="_blank">Try now</a>
                      </div>
                      <hr class="" style="border-bottom:1 px solid  #e0e0e0; margin: 20px 0;">
                      <div>
                        <p class="d-flex justify-content-between text-9696"> <span class="f-16 font-weight-500">
                            Includes</span> <span class="f-12 ">Per month</span></p>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">01</span>Premium partner credits

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Premium Partner Credits</p>
                            <p class="f-12 mb-0 font-weight-normal">Access our exclusive Talent Research Partner to find
                              contact information of talent that is not available online.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">03</span>Job description parsing

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Job Description Parsing</p>
                            <p class="f-12 mb-0 font-weight-normal">Webbtree reads your job description and suggests the
                              right keywords for you to find relevant talent.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">03</span>Talent Pipeline

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent Pipeline</p>
                            <p class="f-12 mb-0 font-weight-normal">Use Talent Pipelines to build lists of talent based
                              on your search.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">100</span>Email outreaches

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Email Outreaches</p>
                            <p class="f-12 mb-0 font-weight-normal">Send emails campaigns using set templates with the
                              ability to integrate your Gmail / Outlook inboxes.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2 mt-1"></i>
                          Talent CRM - track call logs, notes, pipeline status, tags, etc.

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent CRM</p>
                            <p class="f-12 mb-0 font-weight-normal">Track call logs, notes, pipeline status, tags,
                              against pool of candidates.</p>
                          </div>
                        </div>
                        <div class="f-14 text-9696 d-flex align-items-center mb-2 wctooltip">
                          <span class="cross-icon mr-2">+</span>
                          <span style="text-decoration: line-through;">CSV Export</span>
                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">CSV Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export your Webbtree database with all candidate
                              information in CSV format</p>
                          </div>
                        </div>
                        <div class="f-14 text-9696 d-flex align-items-center mb-2 wctooltip">
                          <span class="cross-icon mr-2">+</span>
                          <span style="text-decoration: line-through;">PDF Export</span>

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">PDF Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export candidates in your Webbtree database in
                              custom PDF formats.</p>
                          </div>
                        </div>
                        <div class="f-14 text-9696 d-flex align-items-center wctooltip">
                          <span class="cross-icon mr-2">+</span>
                          <span style="text-decoration: line-through;">Team Management</span>

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Team Management</p>
                            <p class="f-12 mb-0 font-weight-normal">Invite members to collaborate on the talent database
                              and manage credit distribution.</p>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="price-card mx-3">
                      <p class="f-22 font-weight-600 text-9696">Pro</p>
                      <div class="d-flex justify-content-between align-items-center mb-3"><span
                          class="f-22 font-weight-600 text-black">$39<span
                            class="f-16 font-weight-normal">/mo</span></span>

                        <div class="f-12  text-9696 text-right">
                          Billed monthly</div>
                      </div>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3"><i
                          class="fas fa-address-book price-text-color mr-1"></i>300 Contact Credits
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Contact Credits</p>
                          <p class="f-12 mb-0 font-weight-normal">Get real time verified emails and direct dial phone
                            numbers of any LinkedIn profile at the click of a button.</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3">
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Profile Extractions</p>
                          <p class="f-12 mb-0 font-weight-normal">Extract all relevant information from candidate’s
                            profiles to maintain talent CRM</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600  wctooltip mb-3"><i
                          class="fas fa-search price-text-color mr-1"></i> Unlimited X-Ray Searches
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">X-Ray Searches</p>
                          <p class="f-12 mb-0 font-weight-normal">X-Ray search sites like LinkedIn, Github,
                            Stackoverflow and more without having to write complex boolean search strings.</p>
                        </div>
                      </div>

                      <div class="text-center">
                        <a data-testid="auto-app-pricing-a-4" class="select-plan-btn text-center" (click)="chooseplan('Pro','monthly')"  [ngClass]="{'p-none' : activeplan?.paymentplanname == 'Pro' && activeplan?.plantype == 'monthly'}"
                          target="_blank"> {{activeplan?.paymentplanname == 'Pro' && activeplan?.plantype == 'monthly' ? 'Current Plan' :  'Choose plan' }}</a>
                      </div>
                      <hr class="" style="border-bottom:1 px solid  #e0e0e0; margin: 20px 0;">
                      <div>
                        <p class="d-flex justify-content-between text-9696"> <span class="f-16 font-weight-500">
                            Includes</span> <span class="f-12 ">Per month</span></p>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">05</span>Premium partner credits

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Premium Partner Credits</p>
                            <p class="f-12 mb-0 font-weight-normal">Access our exclusive Talent Research Partner to find
                              contact information of talent that is not available online.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">10</span>Job description parsing

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Job Description Parsing</p>
                            <p class="f-12 mb-0 font-weight-normal">Webbtree reads your job description and suggests the
                              right keywords for you to find relevant talent.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">10</span>Talent Pipeline

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent Pipeline</p>
                            <p class="f-12 mb-0 font-weight-normal">Use Talent Pipelines to build lists of talent based
                              on your search.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">750</span>Email outreaches

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Email Outreaches</p>
                            <p class="f-12 mb-0 font-weight-normal">Send emails campaigns using set templates with the
                              ability to integrate your Gmail / Outlook inboxes.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2 mt-1"></i>
                          Talent CRM - track call logs, notes, pipeline status, tags, etc.

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent CRM</p>
                            <p class="f-12 mb-0 font-weight-normal">Track call logs, notes, pipeline status, tags,
                              against pool of candidates.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center mb-2 wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          CSV Export
                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">CSV Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export your Webbtree database with all candidate
                              information in CSV format</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center mb-2 wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>PDF Export

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">PDF Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export candidates in your Webbtree database in
                              custom PDF formats.</p>
                          </div>
                        </div>
                        <div class="f-14 text-9696 d-flex align-items-center wctooltip">
                          <span class="cross-icon mr-2">+</span>
                          <span style="text-decoration: line-through;">Team Management</span>
                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Team Management</p>
                            <p class="f-12 mb-0 font-weight-normal">Invite members to collaborate on the talent database
                              and manage credit distribution.</p>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="price-card mr-3 ultimate-card position-relative">
                      <div class="label-container">
                        <div class="corner"><span>Most <br>
                            Popular</span>
                          <div class="top-corner-box">

                          </div>
                        </div>
                      </div>
                      <p class="f-22 font-weight-600 text-9696">Ultimate</p>
                      <div class="d-flex justify-content-between align-items-center mb-3"><span
                          class="f-22 font-weight-600 text-black">$99<span
                            class="f-16 font-weight-normal">/mo</span></span>

                        <div class="f-12  text-9696 text-right">

                          Billed monthly</div>
                      </div>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3"><i
                          class="fas fa-address-book price-text-color mr-1"></i>900 Contact Credits
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Contact Credits</p>
                          <p class="f-12 mb-0 font-weight-normal">Get real time verified emails and direct dial phone
                            numbers of any LinkedIn profile at the click of a button.</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3">
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Profile Extractions</p>
                          <p class="f-12 mb-0 font-weight-normal">Extract all relevant information from candidate’s
                            profiles to maintain talent CRM</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600  wctooltip mb-3"><i
                          class="fas fa-search price-text-color mr-1"></i> Unlimited X-Ray Searches
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">X-Ray Searches</p>
                          <p class="f-12 mb-0 font-weight-normal">X-Ray search sites like LinkedIn, Github,
                            Stackoverflow and more without having to write complex boolean search strings.</p>
                        </div>
                      </div>

                      <div class="text-center">
                        <a data-testid="auto-app-pricing-a-5" class="select-plan-btn text-center" (click)="chooseplan('Ultimate','monthly')" [ngClass]="{'p-none' : activeplan?.paymentplanname == 'Ultimate' && activeplan?.plantype == 'monthly'}"
                          target="_blank"> {{activeplan?.paymentplanname == 'Ultimate' && activeplan?.plantype == 'monthly' ? 'Current Plan' :  'Choose plan' }}</a>
                      </div>
                      <hr class="" style="border-bottom:1 px solid  #e0e0e0; margin: 20px 0;">
                      <div>
                        <p class="d-flex justify-content-between text-9696"> <span class="f-16 font-weight-500">
                            Includes</span> <span class="f-12 ">Per month</span></p>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">10</span>Premium partner credits

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Premium Partner Credits</p>
                            <p class="f-12 mb-0 font-weight-normal">Access our exclusive Talent Research Partner to find
                              contact information of talent that is not available online.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">40</span>Job description parsing

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Job Description Parsing</p>
                            <p class="f-12 mb-0 font-weight-normal">Webbtree reads your job description and suggests the
                              right keywords for you to find relevant talent.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">Unlimited</span> Talent Pipeline

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent Pipeline</p>
                            <p class="f-12 mb-0 font-weight-normal">Use Talent Pipelines to build lists of talent based
                              on your search.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">2,000</span>Email outreaches

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Email Outreaches</p>
                            <p class="f-12 mb-0 font-weight-normal">Send emails campaigns using set templates with the
                              ability to integrate your Gmail / Outlook inboxes.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2 mt-1"></i>
                          Talent CRM - track call logs, notes, pipeline status, tags, etc.

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent CRM</p>
                            <p class="f-12 mb-0 font-weight-normal">Track call logs, notes, pipeline status, tags,
                              against pool of candidates.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center mb-2 wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          CSV Export
                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">CSV Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export your Webbtree database with all candidate
                              information in CSV format</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center mb-2 wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>PDF Export

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">PDF Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export candidates in your Webbtree database in
                              custom PDF formats.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>Team Management

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Team Management</p>
                            <p class="f-12 mb-0 font-weight-normal">Invite members to collaborate on the talent database
                              and manage credit distribution.</p>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="price-card mr-3 ">
                      <p class="f-22 font-weight-600 text-9696">Enterprise</p>
                      <p class="d-flex justify-content-between align-items-center"><span
                          class="f-22 font-weight-600 text-black">Custom</span><span class="f-12  text-9696 ">Custom
                          billed</span></p>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3"><i
                          class="fas fa-address-book price-text-color mr-1"></i>Contact Credits
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Contact Credits</p>
                          <p class="f-12 mb-0 font-weight-normal">Get real time verified emails and direct dial phone
                            numbers of any LinkedIn profile at the click of a button.</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3">
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Profile Extractions</p>
                          <p class="f-12 mb-0 font-weight-normal">Extract all relevant information from candidate’s
                            profiles to maintain talent CRM</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600  wctooltip mb-3"><i
                          class="fas fa-search price-text-color mr-1"></i> Unlimited X-Ray Searches
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">X-Ray Searches</p>
                          <p class="f-12 mb-0 font-weight-normal">X-Ray search sites like LinkedIn, Github,
                            Stackoverflow and more without having to write complex boolean search strings.</p>
                        </div>
                      </div>

                      <div class="text-center">
                        <a data-testid="auto-app-pricing-a-6" class="select-plan-btn text-center" (click)="chooseplan('sales')" target="_blank">Contact
                          sales</a>
                      </div>
                      <hr class="" style="border-bottom:1 px solid  #e0e0e0; margin: 20px 0;">
                      <div>
                        <p class="d-flex justify-content-between text-9696"> <span class="f-16 font-weight-500">
                            Includes</span> <span class="f-12 ">Per month</span></p>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>Premium partner credits

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Premium Partner Credits</p>
                            <p class="f-12 mb-0 font-weight-normal">Access our exclusive Talent Research Partner to find
                              contact information of talent that is not available online.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i> Job description parsing

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Job Description Parsing</p>
                            <p class="f-12 mb-0 font-weight-normal">Webbtree reads your job description and suggests the
                              right keywords for you to find relevant talent.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          Talent Pipeline

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent Pipeline</p>
                            <p class="f-12 mb-0 font-weight-normal">Use Talent Pipelines to build lists of talent based
                              on your search.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          Email outreaches

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Email Outreaches</p>
                            <p class="f-12 mb-0 font-weight-normal">Send emails campaigns using set templates with the
                              ability to integrate your Gmail / Outlook inboxes.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2 mt-1"></i>
                          Talent CRM - track call logs, notes, pipeline status, tags, etc.

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent CRM</p>
                            <p class="f-12 mb-0 font-weight-normal">Track call logs, notes, pipeline status, tags,
                              against pool of candidates.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center mb-2 wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          CSV Export
                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">CSV Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export your Webbtree database with all candidate
                              information in CSV format</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center mb-2 wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>PDF Export

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">PDF Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export candidates in your Webbtree database in
                              custom PDF formats.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>Team Management

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Team Management</p>
                            <p class="f-12 mb-0 font-weight-normal">Invite members to collaborate on the talent database
                              and manage credit distribution.</p>
                          </div>
                        </div>
                      </div>

                    </div>


                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </section>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <section class="feature-section">
        <div class="container-fluid px-0 pb-4">
          <div class="position-relative">
            <div class=" pricing-table-bg-gradient2 position-relative"> </div>
            <div class="position-absolute top-center">
              <div class="container">
                <div class="row mx-0">
                  <div class="col wccard  bg-white shadow-lg p-4 feature-header-margin-top">
                    <div class="row">
                      <div
                        class="col d-flex justify-content-between align-items-center bg-white flex-column flex-sm-row">
                        <div>
                          <p class="f-36 font-weight-600 mb-3">Webbtree ATS</p>
                          <p class="f-14">To get a price estimate for enterprise plan, please contact our sales team</p>
                        </div>
                        <div>
                          <a data-testid="auto-app-pricing-a-7" class="contact-sales-btn mb-2 font-weight-500" href="https://webbtree.com/contact-us"
                            target="_blank">Contact sales</a>
                        </div>
                      </div>
                    </div>
                    <hr>
                    <p class="f-18 font-weight-500 mb-4">All features</p>
                    <div class="row">
                      <div class="col-md-3">
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Unlimited job postings</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Custom Hiring Pipelines</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Interview Scheduling with Google &
                          Outlook Calendar</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Employee Referral</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Talent Pool Management</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Custom User Roles</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> CV parsing</p>
                      </div>
                      <div class="col-md-3">
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Job Requisition Management</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Custom Interview Scorecards
                          and Kits</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span>Job board Integrations</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Resume Parsing Credits</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Social Recruiting</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Access Restrictions based on IP
                          Address</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Contact enrichments</p>
                      </div>
                      <div class="col-md-3">
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Kanban Boards for applicant
                          tracking</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Vendor Management</p>

                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Email campaigning</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Phone, Email & Chat Support</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Custom URL & SSL Certificate</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Smart emails</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span>Talent pipelines</p>
                      </div>
                      <div class="col-md-3">
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Team collaboration</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Integrated Zoom call interview
                          scheduling</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Candidate Application via Email
                        </p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Manage unlimited candidate
                          documents</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Webhook Requests</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Dedicated Account Manager</p>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
    <div class="tab-pane fade show active" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
      <section>

        <div class="container-fluid px-0 pb-4">
          <div class="position-relative">
            <div class=" pricing-table-bg-gradient position-relative"> </div>
            <div class="position-absolute  top-center">
              <div class="container">
                <div class="row">
                  <div class="col d-flex flex-column flex-sm-row">
                    <div class="price-card">
                      <p class="f-22 font-weight-600 text-9696">Starter</p>
                      <p class="d-flex justify-content-between align-items-center"><span
                          class="f-22 font-weight-600 text-black">Free</span><span class="f-12  text-9696 ">No credit
                          card needed</span></p>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3"><i
                          class="fas fa-address-book price-text-color mr-1"></i> 10 Contact Credits
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Contact Credits</p>
                          <p class="f-12 mb-0 font-weight-normal">Get real time verified emails and direct dial phone
                            numbers of any LinkedIn profile at the click of a button.</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3">
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Profile Extractions</p>
                          <p class="f-12 mb-0 font-weight-normal">Extract all relevant information from candidate’s
                            profiles to maintain talent CRM</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600  wctooltip mb-3"><i
                          class="fas fa-search price-text-color mr-1"></i> Unlimited X-Ray Searches
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">X-Ray Searches</p>
                          <p class="f-12 mb-0 font-weight-normal">X-Ray search sites like LinkedIn, Github,
                            Stackoverflow and more without having to write complex boolean search strings.</p>
                        </div>
                      </div>

                      <div class="text-center">
                        <a data-testid="auto-app-pricing-a-8" class="select-plan-btn text-center" href="https://hire.webbtree.com/searchtoolbox-v2"
                          target="_blank" target="_blank">Try now</a>
                      </div>
                      <hr class="" style="border-bottom:1 px solid  #e0e0e0; margin: 20px 0;">
                      <div>
                        <p class="d-flex justify-content-between text-9696"> <span class="f-16 font-weight-500">
                            Includes</span> <span class="f-12 ">Per month</span></p>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">01</span>Premium partner credits

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Premium Partner Credits</p>
                            <p class="f-12 mb-0 font-weight-normal">Access our exclusive Talent Research Partner to find
                              contact information of talent that is not available online.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">03</span>Job description parsing

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Job Description Parsing</p>
                            <p class="f-12 mb-0 font-weight-normal">Webbtree reads your job description and suggests the
                              right keywords for you to find relevant talent.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">03</span>Talent Pipeline

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent Pipeline</p>
                            <p class="f-12 mb-0 font-weight-normal">Use Talent Pipelines to build lists of talent based
                              on your search.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">100</span>Email outreaches

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Email Outreaches</p>
                            <p class="f-12 mb-0 font-weight-normal">Send emails campaigns using set templates with the
                              ability to integrate your Gmail / Outlook inboxes.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2 mt-1"></i>
                          Talent CRM - track call logs, notes, pipeline status, tags, etc.

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent CRM</p>
                            <p class="f-12 mb-0 font-weight-normal">Track call logs, notes, pipeline status, tags,
                              against pool of candidates.</p>
                          </div>
                        </div>
                        <div class="f-14 text-9696 d-flex align-items-center mb-2 wctooltip">
                          <span class="cross-icon mr-2">+</span>
                          <span style="text-decoration: line-through;">CSV Export</span>
                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">CSV Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export your Webbtree database with all candidate
                              information in CSV format</p>
                          </div>
                        </div>
                        <div class="f-14 text-9696 d-flex align-items-center mb-2 wctooltip">
                          <span class="cross-icon mr-2">+</span>
                          <span style="text-decoration: line-through;">PDF Export</span>

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">PDF Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export candidates in your Webbtree database in
                              custom PDF formats.</p>
                          </div>
                        </div>
                        <div class="f-14 text-9696 d-flex align-items-center wctooltip">
                          <span class="cross-icon mr-2">+</span>
                          <span style="text-decoration: line-through;">Team Management</span>

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Team Management</p>
                            <p class="f-12 mb-0 font-weight-normal">Invite members to collaborate on the talent database
                              and manage credit distribution.</p>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="price-card mx-3">
                      <p class="f-22 font-weight-600 text-9696">Pro</p>
                      <div class="d-flex justify-content-between align-items-center mb-3"><span
                          class="f-22 font-weight-600 text-black">$33<span
                            class="f-16 font-weight-normal">/mo</span></span>

                        <div class="f-12  text-9696 text-right" style="margin-top: -20px;">
                          <p class="mb-1">$390</p>
                          Billed annually
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3"><i
                          class="fas fa-address-book price-text-color mr-1"></i>3,600 Contact Credits
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Contact Credits</p>
                          <p class="f-12 mb-0 font-weight-normal">Get real time verified emails and direct dial phone
                            numbers of any LinkedIn profile at the click of a button.</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3">
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Profile Extractions</p>
                          <p class="f-12 mb-0 font-weight-normal">Extract all relevant information from candidate’s
                            profiles to maintain talent CRM</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600  wctooltip mb-3"><i
                          class="fas fa-search price-text-color mr-1"></i> Unlimited X-Ray Searches
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">X-Ray Searches</p>
                          <p class="f-12 mb-0 font-weight-normal">X-Ray search sites like LinkedIn, Github,
                            Stackoverflow and more without having to write complex boolean search strings.</p>
                        </div>
                      </div>

                      <div class="text-center">
                        <a data-testid="auto-app-pricing-a-9" class="select-plan-btn text-center" (click)="chooseplan('Pro','yearly')" [ngClass]="{'p-none' : activeplan?.paymentplanname == 'Pro' && activeplan?.plantype == 'yearly'}"
                          target="_blank">{{activeplan?.paymentplanname == 'Pro' && activeplan?.plantype == 'yearly' ? 'Current Plan' :  'Choose plan' }}</a>
                      </div>
                      <hr class="" style="border-bottom:1 px solid  #e0e0e0; margin: 20px 0;">
                      <div>
                        <p class="d-flex justify-content-between text-9696"> <span class="f-16 font-weight-500">
                            Includes</span> <span class="f-12 ">Per year</span></p>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">60</span>Premium partner credits

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Premium Partner Credits</p>
                            <p class="f-12 mb-0 font-weight-normal">Access our exclusive Talent Research Partner to find
                              contact information of talent that is not available online.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">120</span>Job description parsing

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Job Description Parsing</p>
                            <p class="f-12 mb-0 font-weight-normal">Webbtree reads your job description and suggests the
                              right keywords for you to find relevant talent.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">10</span>Talent Pipeline

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent Pipeline</p>
                            <p class="f-12 mb-0 font-weight-normal">Use Talent Pipelines to build lists of talent based
                              on your search.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">9,000</span>Email outreaches

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Email Outreaches</p>
                            <p class="f-12 mb-0 font-weight-normal">Send emails campaigns using set templates with the
                              ability to integrate your Gmail / Outlook inboxes.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2 mt-1"></i>
                          Talent CRM - track call logs, notes, pipeline status, tags, etc.

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent CRM</p>
                            <p class="f-12 mb-0 font-weight-normal">Track call logs, notes, pipeline status, tags,
                              against pool of candidates.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center mb-2 wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          CSV Export
                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">CSV Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export your Webbtree database with all candidate
                              information in CSV format</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center mb-2 wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>PDF Export

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">PDF Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export candidates in your Webbtree database in
                              custom PDF formats.</p>
                          </div>
                        </div>
                        <div class="f-14 text-9696 d-flex align-items-center wctooltip">
                          <span class="cross-icon mr-2">+</span>
                          <span style="text-decoration: line-through;">Team Management</span>
                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Team Management</p>
                            <p class="f-12 mb-0 font-weight-normal">Invite members to collaborate on the talent database
                              and manage credit distribution.</p>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="price-card mr-3 ultimate-card position-relative">
                      <div class="label-container">
                        <div class="corner"><span>Most <br>
                            Popular</span>
                          <div class="top-corner-box">

                          </div>
                        </div>
                      </div>
                      <p class="f-22 font-weight-600 text-9696">Ultimate</p>
                      <div class="d-flex justify-content-between align-items-center mb-3"><span
                          class="f-22 font-weight-600 text-black">$83<span
                            class="f-16 font-weight-normal">/mo</span></span>

                        <div class="f-12  text-9696 text-right" style="margin-top: -20px;">
                          <p class="mb-1">$990</p>
                          Billed annually
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3"><i
                          class="fas fa-address-book price-text-color mr-1"></i>10,800 Contact Credits
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Contact Credits</p>
                          <p class="f-12 mb-0 font-weight-normal">Get real time verified emails and direct dial phone
                            numbers of any LinkedIn profile at the click of a button.</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3">
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Profile Extractions</p>
                          <p class="f-12 mb-0 font-weight-normal">Extract all relevant information from candidate’s
                            profiles to maintain talent CRM</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600  wctooltip mb-3"><i
                          class="fas fa-search price-text-color mr-1"></i> Unlimited X-Ray Searches
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">X-Ray Searches</p>
                          <p class="f-12 mb-0 font-weight-normal">X-Ray search sites like LinkedIn, Github,
                            Stackoverflow and more without having to write complex boolean search strings.</p>
                        </div>
                      </div>

                      <div class="text-center">
                        <a data-testid="auto-app-pricing-a-10" class="select-plan-btn text-center" (click)="chooseplan('Ultimate','yearly')" [ngClass]="{'p-none' : activeplan?.paymentplanname == 'Ultimate' && activeplan?.plantype == 'yearly'}"
                          target="_blank"> {{activeplan?.paymentplanname == 'Ultimate' && activeplan?.plantype == 'yearly' ? 'Current Plan' :  'Choose plan' }} </a>
                      </div>
                      <hr class="" style="border-bottom:1 px solid  #e0e0e0; margin: 20px 0;">
                      <div>
                        <p class="d-flex justify-content-between text-9696"> <span class="f-16 font-weight-500">
                            Includes</span> <span class="f-12 ">Per year</span></p>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">120</span>Premium partner credits

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Premium Partner Credits</p>
                            <p class="f-12 mb-0 font-weight-normal">Access our exclusive Talent Research Partner to find
                              contact information of talent that is not available online.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">480</span>Job description parsing

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Job Description Parsing</p>
                            <p class="f-12 mb-0 font-weight-normal">Webbtree reads your job description and suggests the
                              right keywords for you to find relevant talent.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">Unlimited</span> Talent Pipeline

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent Pipeline</p>
                            <p class="f-12 mb-0 font-weight-normal">Use Talent Pipelines to build lists of talent based
                              on your search.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          <span class="font-weight-600 mr-1">24,000</span>Email outreaches

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Email Outreaches</p>
                            <p class="f-12 mb-0 font-weight-normal">Send emails campaigns using set templates with the
                              ability to integrate your Gmail / Outlook inboxes.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2 mt-1"></i>
                          Talent CRM - track call logs, notes, pipeline status, tags, etc.

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent CRM</p>
                            <p class="f-12 mb-0 font-weight-normal">Track call logs, notes, pipeline status, tags,
                              against pool of candidates.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center mb-2 wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          CSV Export
                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">CSV Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export your Webbtree database with all candidate
                              information in CSV format</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center mb-2 wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>PDF Export

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">PDF Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export candidates in your Webbtree database in
                              custom PDF formats.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>Team Management

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Team Management</p>
                            <p class="f-12 mb-0 font-weight-normal">Invite members to collaborate on the talent database
                              and manage credit distribution.</p>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="price-card mr-3 ">
                      <p class="f-22 font-weight-600 text-9696">Enterprise</p>
                      <p class="d-flex justify-content-between align-items-center"><span
                          class="f-22 font-weight-600 text-black">Custom</span><span class="f-12  text-9696 ">Custom
                          billed</span></p>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3"><i
                          class="fas fa-address-book price-text-color mr-1"></i>Contact Credits
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Contact Credits</p>
                          <p class="f-12 mb-0 font-weight-normal">Get real time verified emails and direct dial phone
                            numbers of any LinkedIn profile at the click of a button.</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600 wctooltip mb-3">
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">Profile Extractions</p>
                          <p class="f-12 mb-0 font-weight-normal">Extract all relevant information from candidate’s
                            profiles to maintain talent CRM</p>
                        </div>
                      </div>

                      <div class="f-14 text-black font-weight-600  wctooltip mb-3"><i
                          class="fas fa-search price-text-color mr-1"></i> Unlimited X-Ray Searches
                        <div class="tooltiptext">
                          <p class="mb-1 f-12 font-weight-600">X-Ray Searches</p>
                          <p class="f-12 mb-0 font-weight-normal">X-Ray search sites like LinkedIn, Github,
                            Stackoverflow and more without having to write complex boolean search strings.</p>
                        </div>
                      </div>

                      <div class="text-center">
                        <a data-testid="auto-app-pricing-a-11" class="select-plan-btn text-center" (click)="chooseplan('sales')" target="_blank">Contact
                          sales</a>
                      </div>
                      <hr class="" style="border-bottom:1 px solid  #e0e0e0; margin: 20px 0;">
                      <div>
                        <p class="d-flex justify-content-between text-9696"> <span class="f-16 font-weight-500">
                            Includes</span> <span class="f-12 ">Per year</span></p>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>Premium partner credits

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Premium Partner Credits</p>
                            <p class="f-12 mb-0 font-weight-normal">Access our exclusive Talent Research Partner to find
                              contact information of talent that is not available online.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i> Job description parsing

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Job Description Parsing</p>
                            <p class="f-12 mb-0 font-weight-normal">Webbtree reads your job description and suggests the
                              right keywords for you to find relevant talent.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          Talent Pipeline

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent Pipeline</p>
                            <p class="f-12 mb-0 font-weight-normal">Use Talent Pipelines to build lists of talent based
                              on your search.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          Email outreaches

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Email Outreaches</p>
                            <p class="f-12 mb-0 font-weight-normal">Send emails campaigns using set templates with the
                              ability to integrate your Gmail / Outlook inboxes.</p>
                          </div>
                        </div>

                        <div class="f-14 text-black d-flex wctooltip mb-3"><i
                            class="far fa-check text-blue-green mr-2 mt-1"></i>
                          Talent CRM - track call logs, notes, pipeline status, tags, etc.

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Talent CRM</p>
                            <p class="f-12 mb-0 font-weight-normal">Track call logs, notes, pipeline status, tags,
                              against pool of candidates.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center mb-2 wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>
                          CSV Export
                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">CSV Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export your Webbtree database with all candidate
                              information in CSV format</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center mb-2 wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>PDF Export

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">PDF Export</p>
                            <p class="f-12 mb-0 font-weight-normal">Export candidates in your Webbtree database in
                              custom PDF formats.</p>
                          </div>
                        </div>
                        <div class="f-14 text-black d-flex align-items-center wctooltip"><i
                            class="far fa-check text-blue-green mr-2"></i>Team Management

                          <div class="tooltiptext">
                            <p class="mb-1 f-12 font-weight-600">Team Management</p>
                            <p class="f-12 mb-0 font-weight-normal">Invite members to collaborate on the talent database
                              and manage credit distribution.</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="spacer"></div>
      <div class="spacer mb-5"></div>
      <section class="feature-section">
        <div class="container-fluid px-0 pb-4">
          <div class="position-relative">
            <div class=" pricing-table-bg-gradient2 position-relative"> </div>
            <div class="position-absolute top-center">
              <div class="container">
                <div class="row mx-0">
                  <div class="col wccard  bg-white shadow-lg p-4 feature-header-margin-top">
                    <div class="row">
                      <div
                        class="col d-flex justify-content-between align-items-center bg-white flex-column flex-sm-row">
                        <div>
                          <p class="f-36 font-weight-600 mb-3">Webbtree ATS</p>
                          <p class="f-14">To get a price estimate for enterprise plan, please contact our sales team</p>
                        </div>
                        <div>
                          <a data-testid="auto-app-pricing-a-12" class="contact-sales-btn mb-2 font-weight-500" href="https://webbtree.com/contact-us"
                            target="_blank">Contact sales</a>
                        </div>
                      </div>
                    </div>
                    <hr>
                    <p class="f-18 font-weight-500 mb-4">All features</p>
                    <div class="row">
                      <div class="col-md-3">
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Unlimited job postings</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Custom Hiring Pipelines</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Interview Scheduling with Google &
                          Outlook Calendar</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Employee Referral</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Talent Pool Management</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Custom User Roles</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> CV parsing</p>
                      </div>
                      <div class="col-md-3">
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Job Requisition Management</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Custom Interview Scorecards
                          and Kits</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span>Job board Integrations</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Resume Parsing Credits</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Social Recruiting</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Access Restrictions based on IP
                          Address</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Contact enrichments</p>
                      </div>
                      <div class="col-md-3">
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Kanban Boards for applicant
                          tracking</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Vendor Management</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Email campaigning</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Phone, Email & Chat Support</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Custom URL & SSL Certificate</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Smart emails</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span>Talent pipelines</p>
                      </div>
                      <div class="col-md-3">
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Team collaboration</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Integrated Zoom call interview
                          scheduling</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Candidate Application via Email
                        </p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Manage unlimited candidate
                          documents</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Webhook Requests</p>
                        <p class="f-14 d-flex mb-4"> <span class="mr-2"><i
                              class="fas text-blue-green fa-check-circle"></i></span> Dedicated Account Manager</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  </div>
</section>

<section *ngIf="!paymentPage">
  <div class="col-12 wccard py-4">
    <div class="mx-auto col-md-4 py-6 pointer" id="scrollhere">
      <div class="d-flex justify-content-between f-16 font-weight-500">
        <span (click)="paymentPage = true;">
          Choose your plan
        </span>
        <span class="f-20">
          >
        </span>
        <span class="text-underline">
          Billing Information
        </span>
        <span class="f-20">
          >
        </span>
        <span [ngClass]="{'text-underline' : showcheckoutForm }">
          Checkout
        </span>
      </div>
    </div>

    <div class="mx-auto col-md-8">
      <div>
        <form [formGroup]="paymentForm" class="pt-6">
          <div style="border-bottom:  1px dashed #A1A1A1;" class="">
            <div class="justify-content-between d-flex">
              <span class="f-16 font-weight-500 mb-1">
                {{selectedplan?.paymentplanname}} plan
              </span>
              <span style="text-decoration: line-through;" class="f-14" *ngIf="planselected == 'yearly'">
                <i> $ {{returnDividedCost(selectedplan?.plancost,'yearly')}} </i>
              </span>
            </div>
            <div class="justify-content-between d-flex mb-4">
              <span class="f-14" *ngIf="planselected == 'yearly'">
                Recurring annual charge
              </span>
              <span class="f-14" *ngIf="planselected == 'monthly'">
                Recurring monthly charge
              </span>
              <span class="font-weight-500 f-18">
                - ${{selectedplan?.plancost}} <span class="text-dis f-14"> (Plus taxes) </span>
              </span>
            </div>
          </div>
          <p class="f-16 mt-4 mb-4">
            <i class="fas fa-user text-webbtree-green mr-2"></i> Basic Details
          </p>
          <div class="row mr-2">
            <div class="col-md-6">
              <div class="f-12 font-weight-500 mb-2"> Name <span class="text-danger">*</span>
                <input data-testid="auto-app-pricing-input-1" type="text" placeholder="Enter  name" class="wc-form-control nobg mt-3px"
                  formControlName="fname">
              </div>
              <p *ngIf="paymentForm.get('fname').errors?.required && (paymentForm['controls'].fname.dirty || paymentForm['controls'].fname.touched)"
                class="f-12 text-danger"> Name is required</p>
            </div>
            <div class="col-12 mb-4 mt-2 f-12">
              <i class="fas fa-info-circle mr-2 text-dis"> </i> Invoices will be generated against the name that you
              enter here. If you are a business, please enter your company name else enter your full name.
            </div>
          </div>

          <div class="row mr-2">
            <div class="col">
              <div class="f-12 font-weight-500 mb-2"> Email id <span class="text-danger">*</span>
                <input data-testid="auto-app-pricing-input-2" type="text" placeholder="Enter Email id" class="wc-form-control nobg mt-3px"
                  formControlName="emailid">
              </div>
              <p *ngIf="paymentForm.get('emailid').errors?.required && (paymentForm['controls'].emailid.dirty || paymentForm['controls'].emailid.touched)"
                class="f-12 text-danger"> Email id is required</p>
              <p class="text-danger f-12 pt-1" *ngIf="paymentForm['controls'].emailid.hasError('pattern')">
                Must be a valid EmailId</p>
            </div>
            <div class="col">
              <div class="f-12 font-weight-500 mb-2"> Primary Contact Number <span class="text-danger">*</span>
                <ngx-intl-tel-input [preferredCountries]="[CountryISO.UnitedStates, CountryISO.UnitedKingdom]"
                  [enableAutoCountrySelect]="true" [enablePlaceholder]="false" [searchCountryFlag]="true"
                  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
                  [selectedCountryISO]="CountryISO.India" [maxLength]="25"
                  [phoneValidation]="true" [separateDialCode]="separateDialCode" name="phone" formControlName="phone"
                  class="f-12">
                </ngx-intl-tel-input>
              </div>
              <p *ngIf="paymentForm.get('phone').errors?.required && paymentForm['controls'].country.touched"
                class="f-12 text-danger"> Phone number is required</p>
              <p class="f-12 text-danger"
                *ngIf="!paymentForm['controls'].phone.valid && paymentForm['controls'].phone.touched"> Please Enter
                Valid Number </p>
            </div>

          </div>


          <div class="row mr-2">
            <div class="col-6">
              <div class="f-12 font-weight-500 mb-2"> Country <span class="text-danger">*</span>
                <div class="position-relative">
                  <div class="position-relative gray-text mt-3px">
                    <input data-testid="auto-app-pricing-input-3" (input)="getTypeahead('countries',$event)" type="text" placeholder="E.g India"
                      #trigger="matAutocompleteTrigger" class="wc-form-control nobg" #country formControlName="country"
                      [matAutocomplete]="country_name">

                    <mat-autocomplete #country_name="matAutocomplete">
                      <mat-option *ngFor="let country of countryList" [value]="country.countryname"
                        (onSelectionChange)="selectTypeahead(country,'country')">{{country.countryname}}
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                </div>
              </div>
              <p *ngIf="paymentForm.get('country').errors?.required && (paymentForm['controls'].country.dirty || paymentForm['controls'].country.touched)"
                class="f-12 text-danger"> Country is required</p>
            </div>
          </div>

          <div class="mt-4 mx-auto text-center">
            <button data-testid="auto-app-pricing-button-1" type="button" class="btn-trms-small" data-dismiss="modal"
              (click)="route2paymentForm()">Checkout</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<ng-template #planupgrade class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-pricing-button-2" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../../assets/images/handshake-two-color.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">We have received your request to change plan.</p>
          <p class="">Our sales representative will reach out to you shortly</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-pricing-button-3" class="btn-trms-small" (click)="modalService.dismissAll()">Done</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
